module.exports = __webpack_public_path__ + "static/media/URU.fc9e85ce.png";